import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import type { FooterNavItem, FooterSection, FooterSocialItem } from 'hermes-frontlib-ng-01-dsinterno';

@Component({
    selector: 'app-footer',
    templateUrl: './app-footer.component.html',
    styleUrls: ['./app-footer.component.scss'],
    imports: [CommonModule]
})
export class AppFooterComponent {
    @Input() sections: FooterSection[] = [];
    @Input() legalLinks: FooterNavItem[] = [];
    @Input() socialLinks: FooterSocialItem[] = [];

    private readonly expandedSections = new Set<string>();

    toggleSection(sectionLabel: string): void {
        if (this.expandedSections.has(sectionLabel)) {
            this.expandedSections.delete(sectionLabel);
            return;
        }

        this.expandedSections.add(sectionLabel);
    }

    isSectionExpanded(sectionLabel: string): boolean {
        return this.expandedSections.has(sectionLabel);
    }

    getSectionId(sectionLabel: string): string {
        return `footer-section-${sectionLabel.toLowerCase().replaceAll(/[^a-z0-9]+/g, '-')}`;
    }

    getRel(target?: FooterNavItem['target']): string | null {
        return target === '_blank' ? 'noopener noreferrer' : null;
    }

    trackByLabel(_: number, item: FooterNavItem): string {
        return item.label;
    }
}
